import { useCallback } from "react";

// Other components
import { useTranslation } from "react-i18next";
import FormInput from "./FormInput";

// Utils
import {
  AsYouType,
  parsePhoneNumber,
  parsePhoneNumberWithError,
} from "libphonenumber-js";
import { useFormContext, useWatch } from "react-hook-form";
import CountryListInput from "./CountryListInput";
import Countries from "./Helpers/JSON/Countries.json";

export const getParsedPhoneNumber = (phoneNumber = "") => {
  try {
    return new AsYouType().input(parsePhoneNumberWithError(phoneNumber).number);
  } catch {
    return "+";
  }
};

export const extractCountryFromPhoneNumber = (phoneNumber = "", lng = "en") => {
  try {
    return phoneNumber.length > 1
      ? Countries.find((c) => c.code === parsePhoneNumber(phoneNumber).country)
          .name[lng]
      : "";
  } catch {
    return "";
  }
};

interface PhoneNumberInputProps {
  autoFocus?: boolean;
  required?: boolean;
  phoneNumberError?: any;
  phoneNumberRegister: any;
  defaultNumber?: string;
  countryColSpan?: string;
  phoneNumberColSpan?: string;
  mobileName?: string;
  countryName?: string;
}

const PhoneNumberInput = (props: PhoneNumberInputProps) => {
  const { autoFocus, required, phoneNumberError, phoneNumberRegister, defaultNumber, countryColSpan = "col-12 col-md-6", phoneNumberColSpan = "col-12 col-md-6", mobileName = "mobile", countryName = "country" } = props;
  const { control } = useFormContext();
  //Translation hook
  const { t } = useTranslation();

  const countryValue = useWatch({
    name: countryName,
    control,
  });

  const handelCountryChange = useCallback((newCountry: string | null) => {
    // const country = Countries.find(({ code }) => code === newCountry);
    // setCountry(country);
  }, []);

  // useEffect(() => {
  //   if (defaultNumber && defaultNumber !== phoneNumber.number) {
  //     setPhoneNumber({
  //       number: getParsedPhoneNumber(defaultNumber),
  //       isDirty: false,
  //     });

  //     const extractedCountry =
  //       extractCountryFromPhoneNumber(defaultNumber, i18n.languages[0]) || "";
  //     const matchedCountry = Countries.find(
  //       ({ name }) => name[i18n.languages[0]] === extractedCountry,
  //     );
  //     if (matchedCountry) {
  //       setCountry(matchedCountry);
  //     }
  //   }
  // }, [defaultNumber, i18n.languages]);

  // useEffect(() => {
  //   if (country) {
  //     // If country changed manually, we don't necessarily want to reset the phone number
  //     // unless it's the first time or we are switching dial codes.
  //     // However, the original code had this logic.
  //     // Let's refine it: only update if it's dirty or if we explicitly want to prefix the dial code.

  //     onCountryChange(country.name[i18n.languages[0]]);
  //   }
  // }, [country, onCountryChange, i18n.languages]);

  // useEffect(() => {
  //   onPhoneNumberChange(phoneNumber.number);
  // }, [phoneNumber, onPhoneNumberChange]);

  return (
    <div className="row gap-3 gap-md-0">
      <div className={countryColSpan} >
        <CountryListInput
          name={countryName}
          control={control}
          required={required}
          forPhoneNumber
          label={t("country_code")}
          onCountryChange={(code) => handelCountryChange(code)}
        />
      </div>
      <div className={phoneNumberColSpan}>
        <FormInput
          register={phoneNumberRegister}
          type="text"
          name={mobileName}
          id={mobileName}
          required={required}
          label={t("mobile")}
          inputMode="numeric"
          autoFocus={autoFocus}
          error={phoneNumberError}
          errorMessage={phoneNumberError?.message}
          data-test-id="mobile-input"
          disabled={!countryValue}
        />
      </div>
    </div>
  );
};

export default PhoneNumberInput;
